// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"8CzOb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initWorkCardsAnimation", ()=>initWorkCardsAnimation);
var _gsap = require("gsap");
var _scrollTrigger = require("gsap/dist/ScrollTrigger");
(0, _gsap.gsap).registerPlugin((0, _scrollTrigger.ScrollTrigger));
/**
 * Work Cards Fade-in Animation
 * 
 * Animates each work card with a smooth fade-in,
 * blur reduction, and slight upward movement when scrolling into view.
 * Staggered animation for each card.
 */ // Get scroller based on smooth scroll state
const getScroller = ()=>{
    return window.smoothScroll && window.smoothScroll.isRunning ? '#content' : window;
};
function initWorkCardsAnimation() {
    const isMobile = window.innerWidth <= 768;
    if (isMobile) {
        // Mobile: Animate the entire work-cards container
        const workCardsContainer = document.querySelector('.work-cards');
        if (!workCardsContainer) {
            console.warn('No work-cards container found');
            return;
        }
        if (workCardsContainer.dataset.workCardsAnimInit === '1') return;
        workCardsContainer.dataset.workCardsAnimInit = '1';
        // Set initial state for the container
        (0, _gsap.gsap).set(workCardsContainer, {
            autoAlpha: 0,
            y: 32,
            filter: 'blur(8px)'
        });
        (0, _scrollTrigger.ScrollTrigger).create({
            trigger: workCardsContainer,
            start: 'top 80%',
            scroller: getScroller(),
            onEnter: ()=>{
                (0, _gsap.gsap).to(workCardsContainer, {
                    autoAlpha: 1,
                    y: 0,
                    filter: 'blur(0px)',
                    duration: 1.2,
                    ease: 'expo.out',
                    clearProps: 'y,transform,filter',
                    overwrite: false
                });
            },
            onLeaveBack: ()=>{
                (0, _gsap.gsap).to(workCardsContainer, {
                    autoAlpha: 0,
                    y: 32,
                    filter: 'blur(8px)',
                    duration: 0.6,
                    ease: 'power2.in',
                    overwrite: false
                });
            }
        });
    } else {
        // Desktop: Animate individual cards
        const allWorkCards = Array.from(document.querySelectorAll('.work-card'));
        const workCardsInRows = Array.from(document.querySelectorAll('.work-card-row .work-card'));
        const standaloneWorkCards = allWorkCards.filter((card)=>!card.closest('.work-card-row'));
        const targets = [
            ...standaloneWorkCards,
            ...workCardsInRows
        ];
        if (!targets.length) {
            console.warn('No work cards found');
            return;
        }
        const triggerStart = 'top 90%';
        targets.forEach((target, index)=>{
            if (target.dataset.workCardsAnimInit === '1') return;
            target.dataset.workCardsAnimInit = '1';
            // Set initial state: hidden with blur and slight downward offset
            (0, _gsap.gsap).set(target, {
                autoAlpha: 0,
                y: 32,
                filter: 'blur(8px)'
            });
            (0, _scrollTrigger.ScrollTrigger).create({
                trigger: target,
                start: triggerStart,
                scroller: getScroller(),
                onEnter: ()=>{
                    // Beautiful fade-in animation matching the site's aesthetic
                    // Stagger each card by 0.1 seconds
                    (0, _gsap.gsap).to(target, {
                        autoAlpha: 1,
                        y: 0,
                        filter: 'blur(0px)',
                        duration: 1.2,
                        ease: 'expo.out',
                        delay: index * 0.1,
                        clearProps: 'y,transform,filter',
                        overwrite: false
                    });
                },
                onLeaveBack: ()=>{
                    // Fade out when scrolling back up
                    (0, _gsap.gsap).to(target, {
                        autoAlpha: 0,
                        y: 32,
                        filter: 'blur(8px)',
                        duration: 0.6,
                        ease: 'power2.in',
                        overwrite: false
                    });
                }
            });
        });
    }
}
// Initialize when DOM is ready
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initWorkCardsAnimation);
else initWorkCardsAnimation();

},{"gsap":"kKW9v","gsap/dist/ScrollTrigger":"jusUN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}]},["8CzOb"], "8CzOb", "parcelRequire8c58", {})

//# sourceMappingURL=jribh.github.io.22ac6ccf.js.map
